import { useFloating } from '@floating-ui/react';
import { useCallback } from 'react';

const createVirtualReference = (rect: DOMRect) => ({
    getBoundingClientRect: () => rect,
});

export function useTableSelectionOverlayPositioning() {
    const { refs, floatingStyles, update } = useFloating({
        placement: 'top-start',
    });

    const setSelectionPosition = useCallback(
        (selectionRect: DOMRect) => {
            refs.setPositionReference(createVirtualReference(selectionRect));
            update();
        },
        [refs, update],
    );

    return {
        setFloating: refs.setFloating,
        floatingStyles,
        setSelectionPosition,
    };
}
